<template>
  <div>
    <Loading v-if="loading" />

    <v-container v-else class="py-10">
      <Title>Diretoria</Title>

      <v-row justify="center">
        <v-col
          cols="12"
          sm="5"
          md="4"
          v-for="({ img, title, office }, keyItems) in items"
          :key="keyItems"
        >
          <div class="mt-8 item">
            <img
              v-if="img"
              :src="files + img"
              :alt="title"
              class="d-block item-img"
            />

            <div
              v-if="title"
              class="
                text-h6
                primary--text
                font-weight-bold
                text-center
                mt-4
                item-title
              "
            >
              {{ title }}
            </div>

            <div
              v-if="office"
              class="
                text-body-1
                secondary--text
                font-weight-regular
                text-center
                mt-1
              "
            >
              {{ office }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "directors",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 1 / 1;
    object-fit: cover;
    -o-object-fit: cover;
    object-position: center;
    -o-object-position: center;
    width: 100%;
  }
}
</style>
